import * as z from 'zod';
import { LANGUAGE, PAYMENT_PROVIDER } from 'src/features/customers/utils/types';
import { CURRENCY } from 'src/types';

export type CustomerFormSchemaValues = z.infer<typeof customerFormSchema>;
export const customerFormSchema = z
    .object({
        name: z.string().nonempty(),
        uic: z.string().nonempty(),
        external_customer_id: z.int().optional().nullable(),
        stripe_customer_id: z.int().optional().nullable(),
        address: z.string().optional().nullable(),
        tax_registration_number: z.string().optional().nullable(),
        representative: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
        email: z.email().optional().nullable().or(z.literal("")),
        phone: z.string().optional().nullable(),
        language: z.enum(LANGUAGE).optional().nullable(),
        configuration: z.object({
            currency: z.enum(CURRENCY).optional().nullable(),
            payment_provider: z.enum(PAYMENT_PROVIDER).optional().nullable(),
            invoice_grace_period_days: z.int().optional().nullable(),
            locale: z.enum(LANGUAGE).optional().nullable(),
        }).optional().nullable(),
    });